// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"17eda6db","453":"e2686592","455":"151b81b3","977":"f1fa59a0"}[chunkId] + ".chunk.js";
};